import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl    = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * §10.3 — Tenant context on the wire
 *
 * Dev often uses `VITE_SUPABASE_SERVICE_KEY` because PostgREST does not validate the Keycloak JWT.
 * **RLS** in migrations still uses `current_org_id()` for real tenancy when JWT custom claims / session
 * are wired on the host. Production: prefer anon + user-scoped JWT or server-side Edge with service role,
 * and always scope mutations by **org_id** from the trusted session.
 */
const supabaseKey: string =
  import.meta.env.VITE_SUPABASE_SERVICE_KEY ?? supabaseAnonKey;

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession:    false,
    autoRefreshToken:  false,
    detectSessionInUrl: false,
  },
});
